// extracted by mini-css-extract-plugin
module.exports = {"separator":"headerSeparator_separator__2gUpl"};